import {Component} from 'react';
import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';

let source = axios.CancelToken.source();

class Get_Order extends Component {
    constructor() {
        super();
        var date = new Date();
        this.state = {
            st:date.toISOString().split('T')[0],
            ed:date.toISOString().split('T')[0],
            orderno:'',
            filtered:[],
            filteredl:false,
        }
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }

    async componentDidMount() {
        //this.props.get_data_by_date(this.state.st,this.state.ed)
    }
    get_data_by_date = (event) => {
        event.preventDefault()
        this.props.get_data_by_date(this.state.st, this.state.ed)
    }
    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    tabledata=()=> {
        // <td><a href="" onClick={(event => {
        //                     this.showcu(event, false, value.id)
        //                 })}>Edit</a> |<a href="#">Delete</a></td>
        let count = 0;
        let retdata=null;
        console.log(this.props.datas)
        if(this.props.datas!=undefined){
               retdata = this.props.datas.map(value => {
                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    <td>{value.orderdate}</td>
                    <td>{value.order_no}</td>
                    <td>{value.companyname}</td>
                    <td>{value.orgname}</td>
                    <td>{value.desname}</td>
                    <td>{value.cargo_name}</td>
                    <td>{value.volume}</td>
                    <td>{value.sale_type}</td>
                    <td>{value.type}</td>
                    <td>{value.transport_rate_q}</td>
                    <td>{value.cement_rate_q}</td>
                    <td>{value.cement_cost}</td>
                    <td>{value.stdate}</td>
                    <td>{value.eddate}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }
    render() {
        return (
            <div className="row">
                <div className="col-md-6">
                    <div className="card card-primary">
                        <div className="card-header">
                            <h3 className="card-title">Get By Date</h3>
                        </div>
                        <form>
                            <div className="card-body">
                                <div className="form-group">
                                    <label htmlFor="exampleInputEmail1">Start Date</label>
                                    <input name="st" value={this.state.st} onChange={this.inputmgt} type="date" className="form-control"/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="exampleInputEmail1">End Date</label>
                                    <input name="ed" value={this.state.ed} onChange={this.inputmgt} type="date" className="form-control"/>
                                </div>
                            </div>
                            <div className="card-footer">
                                <button onClick={this.get_data_by_date} type="submit" className="btn btn-primary">Get report</button>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card card-primary">
                        <div className="card-header">
                            <h3 className="card-title">Get By Order #</h3>
                        </div>
                        <form>
                            <div className="card-body">
                                <div className="form-group">
                                    <label htmlFor="exampleInputEmail1">Order #</label>
                                    <input type="text" name="orderno" value={this.state.orderno} onChange={this.inputmgt} className="form-control"/>
                                </div>
                            </div>
                            <div className="card-footer">
                                <button type="submit" className="btn btn-primary">Get report</button>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-tools">
                                <div className="input-group input-group-sm" style={{width: '150px'}}>
                                    <input type="text" name="table_search"
                                           className="form-control float-right" placeholder="Search"/>
                                    <div className="input-group-append">
                                        <button type="submit" className="btn btn-default">
                                            <i className="fas fa-search"/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-header">
                            <div className="card-tools">
                                <div className="input-group input-group-sm" style={{width: '150px'}}>
                                    <a href={this.state.urlordercreate}
                                       className="btn btn-xs btn-outline-primary btn-block">New
                                        Order</a>
                                </div>
                            </div>
                        </div>
                        <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                            <table className="table table-head-fixed text-nowrap">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Action</th>
                                    <th>Order Date</th>
                                    <th>Order #</th>
                                    <th>Customer Name</th>
                                    <th>Orgin</th>
                                    <th>Destination</th>
                                    <th>Cargo</th>
                                    <th>Volume</th>
                                    <th>Sale Type</th>
                                    <th>Type</th>
                                    <th>Transport Rate</th>
                                    <th>Cement Rate</th>
                                    <th>Cement Cost</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.tabledata()}
                                </tbody>
                            </table>
                        </div>
                        {/* /.card-body */}
                    </div>
                    {/* /.card */}
                </div>
            </div>
        )
    }
}

export default Get_Order;
